/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { v4 as uuidv4 } from 'uuid';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from '../../../store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-uid-field',
    templateUrl: './uid-field.component.html',
    styleUrls: ['./uid-field.component.scss'],
    standalone: false
})
export class UidFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() isEdit: boolean;
  isHidden = false;
  @Input() dataset: Dataset;

  get value(): any {
    return this._value;
  }
  set value(val: any) {
    if (!val) {
      val = uuidv4();
    }

    this._value = val;
  }
  _value: any;

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field.systemName);

    if (this.field.systemName === 'workflow_step_uid') {
      this.isHidden = true;
    }

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
    }
  }
}
